import { render, staticRenderFns } from "./SettingPrototype.vue?vue&type=template&id=56b051d6&scoped=true&"
import script from "./SettingPrototype.vue?vue&type=script&lang=js&"
export * from "./SettingPrototype.vue?vue&type=script&lang=js&"
import style0 from "./SettingPrototype.vue?vue&type=style&index=0&id=56b051d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b051d6",
  null
  
)

export default component.exports